import React from 'react';
import {contains} from 'underscore'

export const ModuleList = (props) => {

    const doNothing = () => {};

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="row mt-1">
                    <div className="col-lg-12 pre-scrollable" style={{maxHeight: '500px'}}>
                        <table className="table table-striped" style={{fontSize: 'x-small'}}>
                            <thead>
                            <tr>
                                <th style={{verticalAlign: 'middle'}}>
                                    <input name="selectItem" type="checkbox"
                                           checked={Object.keys(props.selectedGtins).length > 0}
                                           onChange={props.toggleAllItems}/>
                                </th>
                                <th>SAP-Artikel</th>
                                <th>Name</th>
                                <th>GTIN</th>
                                <th>Hersteller-Artikelnummer</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {props.moduleItems.map((moduleItem, index) => {

                                const article = moduleItem.article;
                                const isSelected = contains(props.selectedGtins, moduleItem.article.gtin);

                                return (
                                    <tr key={index} onClick={() => props.toggleItemSelection(moduleItem.article.gtin)}>
                                        <td style={{verticalAlign: 'middle'}}>
                                            <input name="selectItem" type="checkbox" checked={isSelected} onChange={doNothing} />
                                        </td>
                                        <td>{article.erpIdno}</td>
                                        <td>{article.name}</td>
                                        <td>{article.gtin}</td>
                                        <td>{article.vendorArticleNumber}</td>
                                        <td></td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ModuleList;


// WEBPACK FOOTER //
// ./src/admin/areacontrol/admin/ModuleList.js